<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.order.actions.deleteOrder.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('components.order.actions.deleteOrder.title'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :loading="loading"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Order } from '~/_api/models/order'

interface Props {
  order: Order
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()

const info = computed(() => {
  return $i18n.t('components.order.actions.deleteOrder.info', { number: props.order.orderNumber })
})

const open = () => {
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.order.delete(props.order)

    if (response.success) {
      emit('success')
      emit('update:loading', false)

      $notification.toast({
        title: $i18n.t('components.order.actions.deleteOrder.success'),
        text: $i18n.t('components.order.actions.deleteOrder.successInfo'),
        variant: 'success',
      })

      return true
    }
  } catch (e: any) {
    $notification.toast({
      title: $i18n.t('general.error'),
      text: $i18n.t('components.order.actions.deleteOrder.errorInfo'),
    })
  }

  emit('update:loading', false)
}

defineExpose({ open })
</script>
